<template>
		<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>

		<div class="d-flex h-full flex-column">
				<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">
	<!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
	<div class="container pdt-50">
					<div class="t-color-headlineBlack t-headline15 font-b">{{$t('3205')}}</div>
					<div class="divider mgt-24"></div>
	</div>
	<div class="container mgt-24 pdb-50">
					<div class="d-flex mgb-16 flex-wrap"  v-if="popularTag && popularTag.length">
						<template 	v-for="(tag, index) in popularTag">
							<div
									:key="index"
										v-if="firstSelectedTags.includes(tag.id)"
										class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center">
														#{{tag.name}}
								</div>
						</template>
					</div>
				<div class="d-grid-3-24" v-if="boardSocialData && boardSocialData.content && boardSocialData.content.length">

					<div v-for="(boardData, indexSocial) in boardSocialData.content" :key="indexSocial+'_board'">
						<div class="mdc-card  mgb-24 pdt-24 pdb-12 pdl-24 pdr-24 cursor-pointer">
							<div  @click="moveToDetail(boardData)" @keypress="moveToDetail(boardData)" tabindex="0">
							<div class="d-flex">
								<div class="list-image-small">
									<img
												v-if="boardData.auditor.register.profile"
												:src="boardData.auditor.register.profile"
												class="circle icon52 h-52" alt="" />
										<img v-else src="/images/user.png" class="circle icon52 h-52" alt="">
								</div>
								<div class="flex-grow-1 pdl-16">
									<div class="d-flex justify-content-between">
										<div class="t-body3 mgb-1 font-r mgb-4">{{ boardData.auditor.register.name.fullName }}</div>
										<div class="t-body3 font-r t-color-bodyGrayA">{{ $moment(boardData.auditor.register.time).format("L") }}</div>
									</div>
									<div class="d-flex user-list-info">
										<div class="t-body3  t-color-bodyGrayA font-r pdr-8 mgr-8" v-if="boardData.auditor.register.storeName">{{ boardData.auditor.register.storeName }}</div>
										<div class="t-body3  t-color-bodyGrayA font-r pdr-8  mgr-8">{{ boardData.auditor.register.responsibilityName }}</div>
									</div>
								</div>
							</div>
							<div class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25" v-if="boardData.contents && boardData.contents.body !== ''">
								<span v-html="listFilter(boardData.contents.body)"></span>
							</div>
							<div class="d-flex mgt-8 flex-wrap" v-if="boardData.tags && boardData.tags.length > 0">
								<div
								 v-for="(tag, i) in boardData.tags" :key="i"
									class="pdl-4 pdr-4 b-radius2 mgr-4 mgb-4 t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center">
									#{{tag.name}}
								</div>
							</div>
							<div class="square-image mgt-16" v-if="boardData.contents.images && boardData.contents.images.length > 0 ">
								<a href="javascript:void(0)" @click="moveToDetail(boardData)" @keypress="moveToDetail(boardData)" tabindex="0">
									<img :src="boardData.contents.images[0].resourceUri" alt="">
								</a>
							</div>
							<div class="d-flex justify-content-between align-items-center mgt-16 mgb-16">
								<div class="d-flex flex-grow-1">
									<div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1430", { str: boardData.likesCount }) }}</div>
									<div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1431", { str: boardData.commentCount }) }}</div>
								</div>
								<div class="t-color-bodyGrayB t-helper font-r ">{{ $t("1432", { str: boardData.commentCount }) }}</div>
							</div>
							</div>
							<div class="divider"></div>
							<div class="d-flex justify-content-evenly mgt-13">
								<button class="mdc-button" @click="patchLikeState(boardData.id, boardData.like,boardData);boardData.like = !boardData.like" @keypress="patchLikeState(boardData.id, boardData.like,boardData);boardData.like = !boardData.like" tabindex="0">
									<span class="mdc-button__ripple"></span>
									<i class="material-icons mdc-button__icon " :class="boardData.like ? 't-color-red' : 't-color-iconInactive'"
										aria-hidden="true">{{boardData.like ? 'favorite' : 'favorite_border'}}</i>
									<span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{ $t("1433") }}</span>
								</button>
								<button class="mdc-button">
									<span class="mdc-button__ripple"></span>
									<i class="material-icons mdc-button__icon t-color-iconInactive"
										aria-hidden="true">chat_border</i>
									<span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{ $t("1434") }}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				</div>
			</main>
		</div>
		</div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import socialApi from "@/api/socialApi.js";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import mainApi from "@/api/mainApi.js";
import {mapState} from 'vuex'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
	name: "TagSerachCourse",
	components: {
		TopAppBar,
		TopAppBarDrawer,
		videoPlayer
	},
		data() {
		return {
			popularTag : null,
   boardSocialData : null,
			firstSelectedTags:[]
		};
	},
	// like and comment count
	computed: {
				...mapState({
						likeCount : state =>  state.social.likeCount,
						viewCount : state =>  state.social.viewCount
				}),
	},

	mixins: [topAppBarMixin],
	mounted() {
		this.firstSelectedTags = this.$route.query.tags.split(",").map(Number);
  // fetch all tags data
			mainApi
			.fetchPopularTag()
			.then((response) => {
				this.popularTag = response.data.data;
			})
			.catch((err) => { });
			let params = {size: 10, tags: this.$route.query.tags}
		mainApi.fetchPopularTagSocialLearning(params)
			.then((response) => {
					this.boardSocialData = response.data.data;
			})
			.catch((err) => {
				responseData = err.response.data.meta;
				this.$error({ content: responseData.errMsg }).then(() => {});
			});
	},
	methods : {
		// Move to social laerning detail based on board
		moveToDetail(record) {
			if (record && record.id) {
				this.$router.push('/socialLearning/'+record.boardDto.identifier+'/'+record.id+'?boardName='+encodeURI(record.boardDto.name))
			}
		},
		// like and dislike post
		patchLikeState(id, status,record) {
			this.$showLoading();
			let action = status
				? socialApi.patchPostLike(record.boardDto.identifier, id)
				: socialApi.patchPostDislike(record.boardDto.identifier, id);

			action
				.then(response => {
					this.$hideLoading();
					record.likesCount = response.data.data.likesCount;
					//this.detail.like = !status;
				})
				.catch(err => {
					this.$error({ content: err.errMsg }).then(() => {});
				});
		},
		// check image or video
		getType(contentType) {
			return contentType.split('/')[0]
		},
		// apply limited char
		listFilter(str){
			let length = 90;
			let ending = ' ...';
			let str1='';
			if (str.length > length) {
				str1 = str.substring(0, length - ending.length) + ending;
				return str1.replace(/(\r\n|\n|\r)/gm, '<br/>')
			} else {
				return str.replace(/(\r\n|\n|\r)/gm, '<br/>');
			}
		},
	}
}
</script>
